module.exports = __webpack_public_path__ + "img/apple-watch.c51a5f8c.png";